Ext.define('SA.view.pvt.Text', {
    alias: 'widget.pvt-text',
    extend: 'Ext.Component',

    baseCls: 'sa-pvt-text',

    initComponent() {
        this.callParent();

        this.html = this.text;
    }
});